import React from 'react';
import {Link} from 'react-router-dom';

import Authenticated from 'Components/Layouts/Authenticated';
import {Loading} from 'Components/Partials';
import SocketIndicator from 'Components/Utilities/SocketIndicator';

import User from 'Services/User';
import {translation} from 'Services/TranslationHelpers';

import Base from './Base';
import { asset } from "Services/BaseHelpers";
import MainstageQuestionsStandAlone from "Components/MainStage/MainStageQuestionsStandAlone";

export default class MainStageQuestions extends Base {
    /**
     * @var success
     * @type {boolean}
     */
    remote_control = false;

    /**
     * @var state
     */
    state = {
        working: false,
        sessions: null,
        currentSession: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {working, currentSession} = this.state;
        const params = new URLSearchParams(window.location.search);
        const screenMode = params.get('screen') === '1';
        const aspect = params.get('aspect');

        const rootClass = screenMode
            ? 'bg-app-blue min-h-screen w-full flex items-center justify-center'
            : 'bg-white bg-cover bg-no-repeat h-screen overflow-y-auto w-full';

        const innerStyle = screenMode && aspect !== 'side' ? { aspectRatio: '16 / 9' } : {};
        const innerClass = screenMode
            ? (aspect === 'side'
                ? 'w-[1152px] h-[1536px] mx-auto flex flex-col'
                : 'w-full max-w-[1920px] mx-auto flex flex-col')
            : '';

        return (
            <div className={rootClass}>
                <div className={innerClass} style={innerStyle}>
                    {/*{!screenMode && (*/}
                    {/*    <div className=" w-full flex justify-center items-center pt-36 md:pt-0 mb-5">*/}
                    {/*        <img*/}
                    {/*            src={ asset ( '/images/box-text.png' ) }*/}
                    {/*            alt="logo"*/}
                    {/*            className="h-60"*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*)}*/}

                    <div className={`${screenMode ? 'p-4 lg:px-8 flex-1 flex' : 'p-4 md:px-0 pt-20 md:pt-0 lg:px-16'} mx-auto pb-8 px-4 relative z-10 w-full`}>
                        {working && (<Loading/>) }

                        {!working && (
                            <React.Fragment>
                                {!currentSession &&
                                    <div className="bg-main-stage-comments overflow-hidden rounded-xl sm:shadow w-full py-5 text-white text-center">
                                        {translation('main_stage_frontend', 'no_sessions_live_come_back_later')}
                                    </div>
                                }

                                {currentSession && (
                                    <div className="flex mx-auto max-w-4xl w-full px-2">
                                        {this.renderQuestion(screenMode)}
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method renderQuestion
     * @return {JSX.Element}
     */
    renderQuestion = () => (
        <MainstageQuestionsStandAlone
            heightRestriction={false}
            readOnly={true} sessionId={this.state.currentSession.id} />
    );
}
